module.exports = __webpack_public_path__ + "static/media/new_casing_bg_icon_png.024e3416.png";